import React from 'react';

import TextPancake from './pancakes/Text';
import TextImage from './pancakes/TextImage';
import FeaturesHighlightPancake from './pancakes/FeaturesHighlight';
import CustomerQuote from './pancakes/CustomerQuote';
import CustomerQuotes from './pancakes/CustomerQuotes';
import PreFooter from './pancakes/PreFooter';
import Explore from './pancakes/Explore';
import Video from './pancakes/Video';
import TrySourceControlProvider from './pancakes/TrySourceControlProvider';
import Logos from './pancakes/Logos';
import Jobs from './pancakes/Jobs';
import Team from './pancakes/Team';
import Schedule from './pancakes/Schedule';
import HubspotFormPancake from './pancakes/HubspotForm';
import BlogPostsListing from './pancakes/BlogPostsListing';
import VideosList from './pancakes/VideosList';
import Speakers from './pancakes/Speakers';
import Cards from './pancakes/Cards';
import TextSidebar from './pancakes/TextSidebar';
import Tabs from './pancakes/Tabs';
import Calcom from './pancakes/Calcom';
import ProductTourPancake from './pancakes/ProductTour';
import Benefits from './pancakes/Benefits';
import CaseStudies from './pancakes/CaseStudies';
import G2Reviews from './pancakes/G2Reviews';

const PancakesStack = ({ pancakes }) => {
  const stack = [];
  pancakes.forEach((pancake, index) => {
    if (pancake?._type === 'pancakeText') {
      stack.push(
        <TextPancake
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          blocks={pancake._rawPancakeText}
          theme={pancake.theme}
          key={pancake._key}
        ></TextPancake>
      );
    }
    if (pancake?._type === 'featuresHighlight') {
      stack.push(
        <FeaturesHighlightPancake
          features={pancake._rawFeatures}
          highlights={pancake._rawHighlights}
          theme={pancake.theme}
          key={pancake._key}
        />
      );
    }
    if (pancake?._type === 'customerQuote') {
      stack.push(
        <CustomerQuote
          authorName={pancake.author?.name}
          authorJobTitle={pancake.author?.jobtitle}
          authorCompanyName={pancake.author?.company?.name}
          showAuthorsCompany={pancake.showAuthorsCompany}
          authorThumbnail={pancake.author?.image}
          key={pancake._key}
        >
          {pancake.quote}
        </CustomerQuote>
      );
    }
    if (pancake?._type === 'customerQuotes') {
      stack.push(
        <CustomerQuotes
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          quotes={pancake.quotes}
          theme={pancake.theme}
          key={pancake._key}
        />
      );
    }
    if (pancake?._type === 'preFooter') {
      stack.push(
        <PreFooter
          title={pancake.title}
          text={pancake.text}
          callToActions={pancake.callToActions?.callToActions}
          theme={pancake.theme}
          key={pancake._key}
        />
      );
    }
    if (pancake?._type === 'explore') {
      stack.push(
        <Explore
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          textColumn={pancake._rawText}
          customCards={pancake.cards}
          theme={pancake.theme}
          key={pancake._key}
        />
      );
    }
    if (pancake?._type === 'textImage') {
      stack.push(
        <TextImage
          pancakeTitle={pancake.pancakeIntro?.pancakeTitle}
          pancakeText={pancake.pancakeIntro?.pancakeText}
          text={pancake._rawText}
          image={pancake.image}
          video={pancake.video}
          imagePosition={pancake.imagePosition}
          theme={pancake.theme}
          key={pancake._key}
        />
      );
    }
    if (pancake?._type === 'pancakeVideo') {
      stack.push(
        <Video
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          videoFile={pancake.videoFile}
          videoURL={pancake.videoURL}
          blocks={pancake._rawPancakeText}
          youtubeVideo={pancake.youtubeVideo}
          theme={pancake.theme}
          key={pancake._key}
        />
      );
    }
    if (pancake?._type === 'trySourceControlProvider') {
      stack.push(
        <TrySourceControlProvider
          title={pancake.title}
          theme={pancake.theme}
          key={pancake._key}
        />
      );
    }
    if (pancake?._type === 'logos') {
      stack.push(
        <Logos
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          logos={pancake.logos}
          theme={pancake.theme}
          showCompanyName={pancake.showCompanyName}
          roundedLogos={pancake.roundedLogos}
          useLogomarkVersion={pancake.useLogomarkVersion}
          wrapLogosInCards={pancake.wrapLogosInCards}
          useMarquee={pancake.useMarquee}
          key={pancake._key}
        />
      );
    }
    if (pancake?._type === 'jobs') {
      stack.push(
        <Jobs
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          theme={pancake.theme}
          key={pancake._key}
        />
      );
    }
    if (pancake?._type === 'team') {
      stack.push(
        <Team
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          investors={pancake.investors}
          employees={pancake.employees}
          theme={pancake.theme}
          key={pancake._key}
        />
      );
    }
    if (pancake?._type === 'speakers') {
      stack.push(
        <Speakers
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          speakers={pancake.speakers}
          theme={pancake.theme}
          key={pancake._key}
        />
      );
    }
    if (pancake?._type === 'schedule') {
      stack.push(
        <Schedule
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          sessions={pancake.sessions}
          theme={pancake.theme}
          key={pancake._key}
        />
      );
    }
    if (pancake?._type === 'hubspotForm') {
      stack.push(
        <HubspotFormPancake
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          blocks={pancake._rawPancakeText}
          formId={pancake.hubspotFormID}
          theme={pancake.theme}
          key={pancake._key}
          useChiliPiper={pancake.useChiliPiper}
          customChiliPiperRouter={pancake.customChiliPiperRouter}
        ></HubspotFormPancake>
      );
    }
    if (pancake?._type === 'calcom') {
      stack.push(
        <Calcom
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          blocks={pancake._rawPancakeText}
          formURL={pancake.formURL}
          theme={pancake.theme}
          key={pancake._key}
        ></Calcom>
      );
    }
    if (pancake?._type === 'blogPostsListing') {
      stack.push(
        <BlogPostsListing
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          posts={pancake.blogPosts}
          theme={pancake.theme}
          key={pancake._key}
        ></BlogPostsListing>
      );
    }
    if (pancake?._type === 'videosList') {
      stack.push(
        <VideosList
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          videos={pancake.videos}
          filteredVideos={pancake.filteredVideos}
          showFilters={pancake.showFilters}
          theme={pancake.theme}
          key={pancake._key}
        ></VideosList>
      );
    }
    if (pancake?._type === 'cards') {
      stack.push(
        <Cards
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          cards={pancake.cards}
          theme={pancake.theme}
          key={pancake._key}
        ></Cards>
      );
    }
    if (pancake?._type === 'textSidebar') {
      stack.push(
        <TextSidebar
          text={pancake._rawText}
          sidebarPancakes={pancake.sidebarPancakes}
          theme={pancake.theme}
          key={pancake._key}
        ></TextSidebar>
      );
    }
    if (pancake?._type === 'tabs') {
      stack.push(
        <Tabs
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          tabs={pancake.tabs}
          theme={pancake.theme}
          key={pancake._key}
        ></Tabs>
      );
    }
    if (pancake?._type === 'pancakeProductTour') {
      stack.push(
        <ProductTourPancake
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          callToAction={pancake.callToAction}
          image={pancake.image}
          theme={pancake.theme}
          key={pancake._key}
        />
      );
    }
    if (pancake?._type === 'pancakeBenefits') {
      stack.push(
        <Benefits
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          callToAction={pancake.callToAction}
          benefits={pancake.benefits}
          theme={pancake.theme}
          key={pancake._key}
        />
      );
    }
    if (pancake?._type === 'g2Reviews') {
      stack.push(
        <G2Reviews
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          reviews={pancake.reviews}
          theme={pancake.theme}
          key={pancake._key}
        />
      );
    }
    if (pancake?._type === 'pancakeCaseStudies') {
      stack.push(
        <CaseStudies
          title={pancake.pancakeIntro?.pancakeTitle}
          text={pancake.pancakeIntro?.pancakeText}
          callToAction={pancake.callToAction}
          caseStudies={pancake.caseStudies}
          logos={pancake.logos}
          theme={pancake.theme}
          key={pancake._key}
        />
      );
    }
  });
  return stack;
};

export default PancakesStack;
